import { keycloak } from '../keycloak';

export const keycloakService = keycloak;
